import { render, staticRenderFns } from "./UserIpLogs.vue?vue&type=template&id=12d07688&"
import script from "./UserIpLogs.vue?vue&type=script&lang=js&"
export * from "./UserIpLogs.vue?vue&type=script&lang=js&"
import style0 from "./UserIpLogs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports